__turbopack_context__.v({
  "chevron": "Select-module__k3wHdG__chevron",
  "description": "Select-module__k3wHdG__description",
  "label": "Select-module__k3wHdG__label",
  "root": "Select-module__k3wHdG__root",
  "select": "Select-module__k3wHdG__select",
  "selectWrap": "Select-module__k3wHdG__selectWrap",
});
